export default [
	{
		path: '/network/bots',
		name: 'network-bots-list',
		component: () => import(/* webpackChunkName: "BotsList" */ '@/views/network/bots/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,bots',
		},
	},
]
